export enum MembershipType {
  TRIAL = 'TRIAL',
  START = 'START',
  SMART = 'SMART'
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  TRIALING = 'trialing',
  PAUSED = 'paused'
}

export enum Permission {
  VIEW_FORECAST = 'view:forecast',
  VIEW_DASHBOARD = 'view:dashboard',
}

export interface PaymentPlan {
  id: string;
  title: string;
  description: string;
  membership_type: string;
  is_recommended: boolean;
  price_per_month: number;
  price_per_year: number;
  external_product_id: string | null;
  included_locations: number;
}

export interface Membership {
  id: string;
  membership_type: MembershipType;
  valid_to: string;
  is_eligible_for_trial: boolean;
  auto_promotion_code: string | null;
}

export interface BillingHistoryGet {
  id: string;
  invoice_title: string;
  invoice_number: string;
  invoice_url: string;
  tax_amount: number
  discount_amount: number
  subtotal: number
  total: number
  paid_at: string;
  status: string;
}

export interface Customer {
  id: string;
  email: string;
  name: string;
  city: string;
  country: string;
  address: string;
  postal_code: string;
  state: string;
  pec_email_address: string;
  sdi: string;
  vat_id: string;
}

export interface SubscriptionCreate {
  payment_plan_id: string;
  pay_yearly: boolean;
}

export interface SubscriptionGet {
  payment_plan_id: string;
  stripe_subscription_id: string;
  client_secret: string | null;
  status: string | null;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean | null;
  canceled_at: string | null;
  billed_yearly: boolean | null;
}

export interface PaymentMethodUpdateGet {
  client_secret: string;
}

export interface PaymentMethodGet {
  id: string;
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
  is_default: boolean;
}

export interface PaymentMethodsGet {
  cards: PaymentMethodGet[];
}

export interface SubscriptionCostGet {
  tax_amount: number;
  discount_amount: number;
  subtotal: number;
  total: number;
}

export enum LocationMembershipType {
  REGULAR = 'REGULAR',
}

export interface LocationPaymentPlanGet {
  id: string;
  title: string;
  description: string;
  location_membership_type: LocationMembershipType;
  price_per_month: number;
  price_per_year: number;
  external_product_id: string | null;
}


export interface LocationPaymentPlanGet {
  id: string;
  title: string;
  description: string;
  location_membership_type: LocationMembershipType;
  price_per_month: number;
  price_per_year: number;
  external_product_id: string | null;
}

export interface PayableLocationsGet {
  payable_locations: number;
  plan_included_locations: number;
  extra_locations: number;
  location_plan: LocationPaymentPlanGet;
}

export interface CustomerPortalGet {
  url: string;
}

export interface Country {
  code: string;
  name: string | null;
}

export interface PromotionCodeDetailsRequest {
  promotion_code: string;
}

export interface PromotionCodeDetailsGet {
  is_valid: boolean;
  code?: string | null;
  promotion_code_id?: string | null;
  active?: boolean | null;
  expires_at?: string | null;

  percent_off?: number | null;
  amount_off?: number | null;
  currency?: string | null;
  duration?: string | null;
  duration_in_months?: number | null;
}

export interface PromotionCodeAssignRequest {
  auto_promotion_code: string | null;
}

export interface StripeCoupon {
  id: string;
  percent_off?: number | null;
  amount_off?: number | null;
  currency?: string | null;
  duration?: string | null;
  duration_in_months?: number | null;
  max_redemptions?: number | null;
  times_redeemed?: number | null;
  redeem_by?: string | null;
  valid?: boolean | null;
  name?: string | null;
  metadata?: { [key: string]: any };
}

export interface PromotionCodeListItem {
  promotion_code_id: string;
  code: string;
  active: boolean;
  created: string;
  expires_at?: string | null;
  customer?: string | null;
  max_redemptions?: number | null;
  times_redeemed?: number | null;
  metadata?: { [key: string]: any };
  restrictions?: { [key: string]: any } | null;

  coupon: StripeCoupon;
}